import BaseResource                    from '@/lib/data/resource/BaseResource'
import i18n                            from '@/lang/lang'
import { collect }                     from '@/lib/utils/array'
import AssetNameResource               from '@/api/resources/asset/AssetNameResource'
import AssetCodeNameResource           from '@/api/resources/asset/AssetCodeNameResource'
import { toNumberFormatNotationShort } from '@/lib/utils/helper'

export default class NIIHistoricalSpectrumAssetResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    const assetValue = payload?.itemCode || payload?.itemName || ''

    this.Asset = payload.itemName
    this.AssetValue = assetValue.toLocaleLowerCase(i18n.code)

    this.AssetData = {
      name      : payload.itemName,
      values    : payload.data?.cashFlows ?? [],
      color     : 'synthesis-ui-purple-04',
      risk      : payload.data?.risk ? toNumberFormatNotationShort(payload.data.risk) : '0',
      lineSource: payload.data?.finalIndexP1 || '',
      lineTarget: payload.data?.initialIndexP1 || '',
      lineColor : 'synthesis-brand-dark-blue'
    }

    this.AggregateItem = payload.aggregateItem || false
    this.PerCategoryCodes = collect(payload?.perCategoryCodes || [], AssetNameResource)
    this.PerCategoryItems = collect(payload?.perCategoryItems || [], NIIHistoricalSpectrumAssetResource)

    this.PerCategoryNames = payload.perCategoryNames ?? []
    this.PerCategoryCodeNames = collect(payload?.perCategoryCodeNames || [], AssetCodeNameResource)
  }

  /* PROPERTIES */

  /* METHODS */
}
